var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 6 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.012c0 .144-.028.285-.081.415-.054.13-.132.247-.23.342L1.237 11.06a.696.696 0 01-.53.187.716.716 0 01-.498-.272.857.857 0 01-.182-.576.842.842 0 01.236-.552l3.893-3.753c.01-.01.02-.023.025-.037a.118.118 0 00-.025-.128L.263 2.177a.8.8 0 01-.182-.25.868.868 0 01.103-.903.749.749 0 01.232-.193.687.687 0 01.821.133l4.45 4.29c.098.095.177.212.23.343.055.13.083.272.083.415z"
  })));
}

export default SvgSelectRightArrow;